import { AppAction } from "./permissions";
import { useRole } from "./RoleProvider";

/**
 * Imperative hook for permission checks in logic branches.
 *
 * @example
 * const canCreate = usePermission("createConnection");
 * const handleSubmit = () => {
 *   if (!canCreate) return;
 *   // ...
 * };
 */
export function usePermission(action: AppAction): boolean {
  const { can } = useRole();
  return can(action);
}
